interface LightsProps {
  onNavigate: (to: string) => void;
}

interface GameEntry {
  slug: string;
  name: string;
  blurb: string;
  ready: boolean;
}

const GAMES: readonly GameEntry[] = [
  {
    slug: "flashcards",
    name: "Identify the vessel",
    blurb: "See a light arrangement at night, pick the vessel type. Covers IRPCS Part C (Rules 23–30).",
    ready: true,
  },
];

export function Lights({ onNavigate }: LightsProps) {
  return (
    <>
      <p className="muted">
        IRPCS Part C nav-lights catalogue. The full per-vessel catalogue
        — head-on, stern, both beams, plus rule citation and Rule 35 fog
        signal — lives on the Reference tab. Drill identification under
        timed pressure below.
      </p>

      <h2 style={{ marginTop: 24 }}>Games</h2>
      {GAMES.map((g) => (
        <div key={g.slug} className="card">
          <h3 style={{ marginBottom: 4 }}>{g.name}</h3>
          <p className="small muted" style={{ marginBottom: 12 }}>
            {g.blurb}
          </p>
          <button
            onClick={() => onNavigate(`/play/lights/${g.slug}`)}
            className="secondary"
          >
            Play
          </button>
        </div>
      ))}
    </>
  );
}
